import { writable, derived } from "svelte/store";
import { post_index, image_index, post_ids } from "./images.json";
import "svelte-navigator";
const LOCAL_STORAGE_KEY = "yaymukundHasSeenHelp";
const LOCAL_STORAGE_VALUE = "seen";
function hasSeenHelp() {
    return localStorage.getItem(LOCAL_STORAGE_KEY) === LOCAL_STORAGE_VALUE;
}
export const hideHelp = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, LOCAL_STORAGE_VALUE);
    help.set(false);
};
export const help = writable(!hasSeenHelp());
const shortcode = writable(null);
export const currentPostShortcode = derived(shortcode, (s) => {
    if (s) {
        return image_index[s].parent_shortcode;
    }
    else {
        return null;
    }
});
const currentPostIndex = derived(currentPostShortcode, (s) => {
    if (s) {
        return post_ids.indexOf(s);
    }
    else {
        return null;
    }
});
const SURROUNDING_COUNT = 4;
export const surroundingPostShortcodes = derived(currentPostIndex, (idx) => {
    if (idx === null) {
        return post_ids;
    }
    if (idx < SURROUNDING_COUNT + 1) {
        return post_ids.slice(0, 9);
    }
    else if (idx >= post_ids.length - SURROUNDING_COUNT - 1) {
        return post_ids.slice(post_ids.length - SURROUNDING_COUNT * 2 - 1);
    }
    else {
        const start = Math.max(idx - SURROUNDING_COUNT, 0);
        const end = Math.min(idx + SURROUNDING_COUNT, post_ids.length - 1) + 1;
        return post_ids.slice(start, end);
    }
});
export const pageCount = derived([shortcode, currentPostShortcode], ([s, ps]) => {
    if (!s || !ps) {
        return null;
    }
    const post = post_index[ps];
    if (post.image_shortcodes.length === 1) {
        return null;
    }
    const cidx = post.image_shortcodes.indexOf(s) + 1;
    return `${cidx}/${post.image_shortcodes.length}`;
});
export const nextShortcode = derived([shortcode, currentPostShortcode, currentPostIndex], ([s, ps, idx]) => {
    if (!s || !ps || idx === null) {
        return null;
    }
    const post = post_index[ps];
    const children = post.image_shortcodes;
    const cidx = children.indexOf(s);
    if (cidx === children.length - 1) {
        // Got to get the next post.
        if (idx === post_ids.length - 1) {
            return null;
        }
        else {
            const cs = post_index[post_ids[idx + 1]].image_shortcodes;
            return cs[0];
        }
    }
    else {
        return children[cidx + 1];
    }
});
export const prevShortcode = derived([shortcode, currentPostShortcode, currentPostIndex], ([s, ps, idx]) => {
    if (!s || !ps || idx === null) {
        return null;
    }
    const post = post_index[ps];
    const children = post.image_shortcodes;
    const cidx = children.indexOf(s);
    if (cidx === 0) {
        // Got to get the next post.
        if (idx === 0) {
            return null;
        }
        else {
            const cs = post_index[post_ids[idx - 1]].image_shortcodes;
            return cs[cs.length - 1];
        }
    }
    else {
        return children[cidx - 1];
    }
});
export const setShortcode = (s) => shortcode.set(s);
